export default class WindowFactory {
  static CREATE = 0
  static UPDATE = 1
  static DELETE = 2

  create() {
    return {
      status: WindowFactory.CREATE,
      begin_at: 0,
      schedule: [],
    }
  }
}
